"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ImplementationGuide_Page = exports.ImplementationGuide_PageGenerationKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Reference_1 = require("./RTTI_Reference");
var ImplementationGuide_PageGenerationKind;
(function (ImplementationGuide_PageGenerationKind) {
    ImplementationGuide_PageGenerationKind["_html"] = "html";
    ImplementationGuide_PageGenerationKind["_markdown"] = "markdown";
    ImplementationGuide_PageGenerationKind["_xml"] = "xml";
    ImplementationGuide_PageGenerationKind["_generated"] = "generated";
})(ImplementationGuide_PageGenerationKind = exports.ImplementationGuide_PageGenerationKind || (exports.ImplementationGuide_PageGenerationKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_ImplementationGuide_Page = t.recursion('IImplementationGuide_Page', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        nameUrl: t.string,
        _nameUrl: RTTI_Element_1.RTTI_Element,
        nameReference: RTTI_Reference_1.RTTI_Reference,
        title: t.string,
        _title: RTTI_Element_1.RTTI_Element,
        generation: (0, EnumType_1.createEnumType)(ImplementationGuide_PageGenerationKind, 'ImplementationGuide_PageGenerationKind'),
        _generation: RTTI_Element_1.RTTI_Element,
        page: t.array(exports.RTTI_ImplementationGuide_Page)
    });
});
//# sourceMappingURL=RTTI_ImplementationGuide_Page.js.map